import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: 'Wie funktioniert der Kurs?',
    answer: 'Der 7-Tage-Body-Boost ist ein strukturiertes Programm, das dir täglich konkrete Übungen und Anleitungen liefert. Du erhältst Zugang zu Video-Workouts, die du auf nur einem Quadratmeter durchführen kannst, sowie einen klaren Ernährungsplan. Alles ist so gestaltet, dass es in deinen Alltag passt.',
  },
  {
    question: 'Muss ich hungern oder strenge Diät halten?',
    answer: 'Nein, absolut nicht! Der 7-Tage-Body-Boost basiert nicht auf Hungern oder extremen Diäten. Du lernst, wie du deinen Körper richtig nährst und gleichzeitig Fett verbrennst. Es geht um intelligente Ernährung, nicht um Verzicht.',
  },
  {
    question: 'Wie viel Gewicht werde ich verlieren?',
    answer: 'Gesundes Abnehmen bedeutet etwa 1 kg pro Woche. Das Wichtigste ist, dass du dich besser fühlst und mehr Energie hast. Typische Ergebnisse für Menschen mit höherem Übergewicht liegen bei 2-5 kg in den 7 Tagen. Jeder Körper ist anders, aber du wirst definitiv positive Veränderungen spüren.',
  },
  {
    question: 'Für wen ist der Kurs geeignet?',
    answer: 'Der Kurs ist für alle geeignet, die ernsthaft abnehmen und ihre Fitness verbessern möchten. Egal ob Anfänger oder Fortgeschrittene, jung oder älter – das Programm ist so konzipiert, dass es für verschiedene Fitnesslevel funktioniert. Du brauchst nur Motivation und die Bereitschaft, 7 Tage lang dabei zu bleiben.',
  },
  {
    question: 'Wie viel Zeit muss ich täglich investieren?',
    answer: 'Du benötigst etwa 20-30 Minuten pro Tag für die Workouts. Die Übungen sind hocheffektiv und auf maximale Fettverbrennung ausgelegt, sodass du in kurzer Zeit große Ergebnisse erzielst. Dazu kommt die Zeit für die Mahlzeiten, die du sowieso essen würdest.',
  },
  {
    question: 'Gibt es vegetarische oder vegane Optionen?',
    answer: 'Ja! Der Ernährungsplan enthält flexible Optionen und Alternativen, die auch für vegetarische und vegane Ernährung geeignet sind. Du kannst die Mahlzeiten an deine persönlichen Vorlieben anpassen, ohne die Wirksamkeit des Programms zu beeinträchtigen.',
  },
  {
    question: 'Benötige ich spezielle Geräte oder Equipment?',
    answer: 'Nein, du brauchst nur ein Handtuch oder eine Yogamatte und eine Flasche Wasser. Die Workouts funktionieren mit deinem eigenen Körpergewicht und sind auf nur einem Quadratmeter durchführbar. Du kannst sie überall machen – zu Hause, im Hotel oder im Park.',
  },
];

function FAQItem({ question, answer, isOpen, onClick }: FAQItem & { isOpen: boolean; onClick: () => void }) {
  return (
    <div className="border-b border-gray-200 last:border-b-0">
      <button
        onClick={onClick}
        className="w-full py-6 px-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
      >
        <span className="font-semibold text-gray-900 text-lg pr-8">{question}</span>
        <ChevronDown
          className={`w-6 h-6 text-green-600 flex-shrink-0 transition-transform duration-300 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-6 pb-6 text-gray-700 leading-relaxed">{answer}</div>
      </div>
    </div>
  );
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Häufig gestellte Fragen
          </h2>
          <p className="text-xl text-gray-600">
            Alles, was du über den 7-Tage-Body-Boost wissen musst
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {faqData.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onClick={() => toggleItem(index)}
            />
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">Hast du weitere Fragen?</p>
          <a
            href="#offer"
            className="inline-flex items-center gap-2 text-green-600 font-semibold hover:text-green-700 transition-colors"
          >
            Starte jetzt und erlebe es selbst
            <ChevronDown className="w-5 h-5" />
          </a>
        </div>
      </div>
    </section>
  );
}
